import React from 'react';
import { Link } from 'react-router-dom';
import {
  COPYRIGHT_OWNER,
  COPYRIGHT_YEAR,
  COPYRIGHT_CONTACT_EMAIL,
  SYSTEM_NAME,
  COPYRIGHT_SECTIONS,
} from '../constants/copyrightNotice';

const styles = {
  container: { maxWidth: '720px', margin: '0 auto', padding: '0 4px 32px' },
  backLink: {
    display: 'inline-block',
    marginBottom: '16px',
    color: '#2563eb',
    textDecoration: 'none',
    fontSize: '0.9rem',
  },
  title: { margin: '0 0 8px 0', fontSize: '1.35rem', color: '#1e293b' },
  subtitle: { margin: '0 0 24px 0', fontSize: '0.9rem', color: '#64748b' },
  section: {
    marginBottom: '24px',
    padding: '20px',
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  sectionTitle: { margin: '0 0 12px 0', fontSize: '1rem', fontWeight: 600, color: '#334155' },
  paragraph: { margin: '0 0 10px 0', fontSize: '0.92rem', lineHeight: 1.75, color: '#475569' },
  list: { margin: '8px 0 12px 0', paddingLeft: '22px', fontSize: '0.92rem', lineHeight: 1.75, color: '#475569' },
  email: { color: '#2563eb', wordBreak: 'break-all' },
};

const CopyrightPage = () => (
  <div style={styles.container}>
    <Link to="/" style={styles.backLink}>← 대시보드로</Link>
    <h2 style={styles.title}>저작권 및 이용 안내</h2>
    <p style={styles.subtitle}>
      {SYSTEM_NAME} · © {COPYRIGHT_YEAR} {COPYRIGHT_OWNER}. All rights reserved.
    </p>

    {COPYRIGHT_SECTIONS.map((section) => (
      <div key={section.title} style={styles.section}>
        <h3 style={styles.sectionTitle}>{section.title}</h3>
        {section.paragraphs.map((text, i) => (
          <p key={i} style={styles.paragraph}>{text}</p>
        ))}
        {section.list && (
          <ul style={styles.list}>
            {section.list.map((item) => (
              <li key={item} style={{ marginBottom: '6px' }}>{item}</li>
            ))}
          </ul>
        )}
        {section.afterList && (
          <p style={styles.paragraph}>{section.afterList}</p>
        )}
        {section.title === '5. 문의' && (
          <p style={styles.paragraph}>
            이메일:{' '}
            <a href={`mailto:${COPYRIGHT_CONTACT_EMAIL}`} style={styles.email}>
              {COPYRIGHT_CONTACT_EMAIL}
            </a>
          </p>
        )}
      </div>
    ))}
  </div>
);

export default CopyrightPage;
